import { useLanguage } from "@/contexts/LanguageContext";
import { useState } from "react";

const MarqueeSection = () => {
  const { t } = useLanguage();
  const text = t('marquee.text');
  const [hovered, setHovered] = useState(false);
  
  return (
    <section 
      className="py-4 sm:py-6 bg-accent overflow-hidden cursor-pointer transition-all duration-300"
      style={{
        backgroundColor: hovered ? 'hsl(11 89% 50%)' : undefined,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="relative flex">
        <div 
          className="flex whitespace-nowrap will-change-transform transition-opacity duration-300"
          style={{
            animation: `marquee-scroll ${hovered ? '60s' : '15s'} linear infinite`,
            opacity: hovered ? 0.9 : 1,
          }}
        >
          {[...Array(8)].map((_, i) => (
            <div key={i} className="flex items-center shrink-0">
              <span 
                className="text-xl sm:text-2xl lg:text-3xl font-display font-bold px-6 sm:px-8 transition-all duration-300"
                style={{
                  color: hovered ? 'hsl(0 0% 100%)' : undefined,
                }}
              >
                {text}
              </span>
              <span 
                className="text-xl sm:text-2xl lg:text-3xl px-3 sm:px-4 transition-all duration-300"
                style={{
                  color: hovered ? 'hsl(0 0% 100% / 0.7)' : undefined,
                }}
              >
                •
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarqueeSection;
